import { Box } from '@mui/material'
import { BatchStatus, DepositStatus, DocumentState, RedemptionStatus } from '../api/types'
import { tokens } from '../theme'

interface StatusMeta {
  label: string
  bg: string
  color: string
}

export type ChipStatus = DepositStatus | BatchStatus | DocumentState | RedemptionStatus

/**
 * Popisky a barvy pro stavové automaty (vklad, přepočet, dokument, odkup). Barvy vycházejí
 * z tokenů: bg = odstín 100, text = odstín 700 (u primary 800, u smazaného tlumené).
 */
const STATUS_META: Record<ChipStatus, StatusMeta> = {
  WAITING_PAYMENT: { label: 'Nezaplaceno', bg: tokens.warning[100], color: tokens.warning[700] },
  PAID: { label: 'Zaplaceno', bg: tokens.success[100], color: tokens.success[700] },
  IN_BATCH: { label: 'V přepočtu', bg: tokens.primary[100], color: tokens.primary[800] },
  POSTED: { label: 'Připsáno', bg: tokens.success[100], color: tokens.success[700] },
  DELETED: { label: 'Smazáno', bg: tokens.neutral[100], color: tokens.neutral[500] },
  DRAFT: { label: 'Rozpracováno', bg: tokens.neutral[100], color: tokens.neutral[700] },
  CHECKED: { label: 'Zkontrolováno', bg: tokens.primary[100], color: tokens.primary[800] },
  CONFIRMED: { label: 'Potvrzeno', bg: tokens.success[100], color: tokens.success[700] },
  REJECTED: { label: 'Zamítnuto', bg: tokens.error[100], color: tokens.error[700] },
  GENERATED: { label: 'Vygenerováno', bg: tokens.primary[100], color: tokens.primary[800] },
  SIGNED: { label: 'Podepsáno', bg: tokens.success[100], color: tokens.success[700] },
  ARCHIVED: { label: 'Archivováno', bg: tokens.neutral[100], color: tokens.neutral[700] },
  CANCELLED: { label: 'Zrušeno', bg: tokens.error[100], color: tokens.error[700] },
  // Odkupy: žádost čeká na CEO, po potvrzení se čeká na odeslání peněz z banky.
  NEW: { label: 'Nová', bg: tokens.warning[100], color: tokens.warning[700] },
  QUEUED: { label: 'Ve frontě', bg: tokens.neutral[100], color: tokens.neutral[700] },
  REQUESTED: { label: 'Oceněno, čeká na potvrzení', bg: tokens.warning[100], color: tokens.warning[700] },
  PAID_OUT: { label: 'Vyplaceno', bg: tokens.success[100], color: tokens.success[700] },
}

export function StatusChip({ status }: { status: ChipStatus }) {
  const meta = STATUS_META[status]
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: '9999px',
        fontWeight: 600,
        fontSize: '0.75rem',
        padding: '2px 10px',
        whiteSpace: 'nowrap',
        bgcolor: meta.bg,
        color: meta.color,
      }}
    >
      {meta.label}
    </Box>
  )
}
